module.exports = __webpack_public_path__ + "img/playlist-img.000424e4.png";